const LeagueImageRecordModule = () => {
  return <h4 style={{ margin: 0 }}>참가자 기념샷</h4>;
};

export default LeagueImageRecordModule;
